/**
 * Main config file where all configurable options are for separate installs of the UI
 */

export default {

    //The base url which will be used for all requests to the API. E.g. https://api.example.org/
    api_base: 'https://restapi.kngs.org/',

    //The ID of the user which will be authenticating onto the API. E.g. user
    client_id: 'kingscamps',

    //The password for the chosen client_id. E.g. 9S:+y3L.P[&Ur-5K
    client_secret: 'tBB32VUaJ7mE9QMkhePBDycjvqPtBB32',

    //Token audience setting used in call to get a new token
    token_audience: 'www.kingscamps.org',

    //The url which will display a list of venues for the user to select when creating a new booking. E.g. /venues
    venues_list_url: 'https://www.kingscamps.org/venue/',

    //Amount of seconds prior to the token expirying for the token to be refreshed.
    //If set to low, the token may have expired by the time the server receives the request
    access_token_refresh_delay: 5,
    //Force test payment mode?
    force_payment_test_mode: 'false',

    //Send order confirmation email?
    send_confirmation_email: 'true',

    //External links in the header.
    header_nav_links: [
        {
            location: 'https://www.kingscamps.org/',
            title: 'Home'
        },
        {
            location: 'https://www.kingscamps.org/programmes/',
            title: 'Programmes'
        },
        {
            location: 'https://www.kingscamps.org/venue/',
            title: 'Venues'
        },
        {
            location: 'https://www.kingscamps.org/how-it-works/',
            title: 'How it works'
        },
        {
            location: 'https://www.kingscamps.org/faqs/',
            title: 'FAQS'
        },
    ],

    //External links in the footer.
    footer_nav_links: [
        {
            location: 'https://www.kingscamps.org/terms-and-conditions/',
            title: 'Terms and conditions'
        },
        {
            location: 'https://www.kingscamps.org/web-policies/',
            title: 'Privacy policy'
        },
        {
            location: 'https://www.kingscamps.org/contact-us/',
            title: 'Contact us'
        },
    ],

    //Amount of time in seconds for the booking_id stored in local storage to be expired.
    booking_id_expiry: 43200,

    //Kings telephone number
    kings_phone_number: '0114 263 2160',

    //Url for the Kings Camps Terms and Conditions page
    kings_terms_and_conditions_link: 'https://www.kingscamps.org/terms-and-conditions/',

    //Base domain of the application (without trailing /)
    base_domain: 'https://booking.kingscamps.org/',

    //Order of times array
    order_times: ['Standard Hours','Extended Hours','Morning Hours'],

    //Specifies how long alerts should show in seconds
    alert_timeout: 15,

    //Google tag manager and facebook pixel codes to integrate    
    external_footer_scripts: "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({\"gtm.start\":new Date().getTime(),event:\"gtm.js\"});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!=\"dataLayer\"?\"&l=\"+l:\"\";j.async=true;j.src=\"https://www.googletagmanager.com/gtm.js?id=\"+i+dl;f.parentNode.insertBefore(j,f);})(window,document,\"script\",\"dataLayer\",\"GTM-M9ZNTCL\"); \"undefined\"==typeof fbq?(!function(e,t,n,f,c,a,o){e.fbq||(c=e.fbq=function(){c.callMethod?c.callMethod.apply(c,arguments):c.queue.push(arguments)},e._fbq||(e._fbq=c),c.push=c,c.loaded=!0,c.version=\"2.0\",c.queue=[],(a=t.createElement(n)).async=!0,a.src=\"https://connect.facebook.net/en_US/fbevents.js\",(o=t.getElementsByTagName(n)[0]).parentNode.insertBefore(a,o))}(window,document,\"script\"),fbq(\"init\",\"1717456265165410\"),fbq(\"track\",\"PageView\"),fbq(\"track\",\"PageView\")):fbq(\"track\",\"PageView\");",

    //Google conversion tracking script - booking complete
    conversion_script_complete: "var google_conversion_id = 951759854;var google_conversion_language = \"en\";var google_conversion_format = \"3\";var google_conversion_color = \"ffffff\";var google_conversion_label = \"8dc8CO_loGEQ7ufqxQM\";var google_remarketing_only = false; $.getScript('//www.googleadservices.com/pagead/conversion.js');",

    // Url for temporary customised week booking page
    custom_week_booking_form: 'https://www.kingscamps.org/booking-request',

    use_short_weeks: false

}



// WEBPACK FOOTER //
// ./src/config/config.js